var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "search" } },
    [
      _c(
        "div",
        { staticClass: "search-type" },
        _vm._l(_vm.$conf.search, function(item, i) {
          return _vm.$conf.search.length > 1
            ? _c(
                "b-radio",
                {
                  key: i,
                  attrs: {
                    name: "searchIndex",
                    size: "is-small",
                    type: "is-info",
                    "native-value": i
                  },
                  model: {
                    value: _vm.index,
                    callback: function($$v) {
                      _vm.index = $$v
                    },
                    expression: "index"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t(item.name)) + "\n    ")]
              )
            : _vm._e()
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("search") } },
        [
          _c("b-input", {
            attrs: {
              type: "search",
              "custom-class": "has-background-grey has-text-light",
              icon: "magnify",
              "icon-right": _vm.query.length ? "close" : "",
              "icon-right-clickable": "",
              placeholder: _vm.$t(
                _vm.$conf.search[_vm.index].name + ".placeholder"
              )
            },
            on: { "icon-right-click": _vm.clearSearch },
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search($event)
              }
            },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }